import contract from '@mailobj-browser/front/js/contracts/contract.js'

export default contract({})
